import { render, staticRenderFns } from "./msgManage.vue?vue&type=template&id=beaf580c&"
import script from "./msgManage.vue?vue&type=script&lang=js&"
export * from "./msgManage.vue?vue&type=script&lang=js&"
import style0 from "./msgManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports